import { integrationsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

export const integrationsCard = {
  element: '#plugins > div.page-content > div.plugin-cards > div.plugin-card',
  popover: {
    title: 'Integration Card',
    description:
      'Each signature card shows key information and lets you manage the integration. Click the <code><i class="os-icon-more-horizontal"></i></code> button for more options, or click on the card to view the integration details.',
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');

      if (actionsToggle) {
        actionsToggle.classList.remove('tour-show');

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    },
    onNextClick: () => {
      const actionsMenu = document.querySelector(
        '#plugins > div.page-content > div > div:nth-child(1) > div.action.tour-show > div > div'
      );

      if (actionsMenu) {
        actionsMenu.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

export const integrationsActionsMenu = {
  element: '#plugins > div.page-content > div > div:nth-child(1) > div.action.tour-show > div > ul',
  popover: {
    title: 'Action Menu',
    description:
      'The integration action menu lets you quickly perform tasks like editing, disabling, or deleting an integration.',
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');

      if (actionsToggle) {
        actionsToggle.classList.remove('tour-show');

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

export const integrationsRulename = {
  element: '#plugins > div.page-content > div > div:nth-child(1) > div.plugin > div:nth-child(2) > div',
  popover: {
    title: 'Integration Name',
    description: `
      The integration name is used to reference this specific integration in email signatures and other areas.
      <br/><br/>
      <strong>Note</strong>
      <br/>
      Use the <code><i class='os-icon-copy'></i></code> button to copy the name to your clipboard.
    `,
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');

      if (actionsToggle) {
        actionsToggle.classList.add('tour-show');

        const actionsMenu = document.querySelector(
          '#plugins > div.page-content > div > div:nth-child(1) > div.action.tour-show > div > div'
        );

        if (actionsMenu) {
          actionsMenu.click();

          GLOBAL_DRIVER_OBJECT.movePrevious();
        }
      }
    },
    onNextClick: () => {
      integrationsSettingsStore.update((integrations) => {
        return {
          ...integrations,
          tours: {
            ...integrations.tours,
            overviewHasToured: true
          }
        };
      });

      GLOBAL_DRIVER_OBJECT.destroy();
    }
  }
};
